import type { ClaimTypeCode } from '@quromedical/fhir-common';
import type {
  ClaimTemplateCreateRequest,
  ClaimTemplateGetAllResponse,
  ClaimTemplateGetResponse,
  ClaimTemplateUpdateRequest,
  ClaimTemplateUpdateResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ClaimTemplateApi {
  public async getClaimTemplates(): Promise<ClaimTemplateGetAllResponse> {
    return await trpcClient.claimTemplate.getAll.query();
  }

  public async getClaimTemplate(
    type: ClaimTypeCode,
  ): Promise<ClaimTemplateGetResponse> {
    return await trpcClient.claimTemplate.getByType.query({ type });
  }

  public async updateClaimTemplate(
    body: ClaimTemplateUpdateRequest,
  ): Promise<ClaimTemplateUpdateResponse> {
    return await trpcClient.claimTemplate.update.mutate({
      ...body,
    });
  }

  public async createClaimTemplate(
    body: ClaimTemplateCreateRequest,
  ): Promise<ClaimTemplateUpdateResponse> {
    return await trpcClient.claimTemplate.create.mutate({
      ...body,
    });
  }
}
